import {buildGlobalApiBaseUrl} from "./featureFlags";

export const buildCSP = () => {
  const backendURL = process.env.GRAPHQL_API;
  const regscoutBackendURL = new URL(process.env.GRAPHQL_API_URL).origin;
  const rexAIURL = process.env.REXAI_API;
  const authURL = process.env.AUTH_ENDPOINT;
  const idAuthURL = process.env.ID_AUTH_ENDPOINT;
  const mediaURL = process.env.MEDIA_URL;
  // The app stack's content CDN, which serves company logos into notification previews.
  const contentURL = process.env.CONTENT_URL;
  const globalApiURL = buildGlobalApiBaseUrl();

  const csp = {
    "base-uri": ["'self'"],
    "default-src": ["'self'"],
    "script-src": [
      "'self'",
      "blob:",
      "'unsafe-eval'",
      "'wasm-unsafe-eval'",
      "https://*.amplitude.com",
      "https://cdn.logrocket.io",
      "https://cdn.lr-ingest.com",
      "https://cdn.lr-ingest.io",
      "https://cdn.lr-in.com",
      "https://cdn.logr-in.com",
      "https://*.intake-lr.com",
      "https://*.lr-in-prod.com",
      "https://*.sdkassets.chime.aws",
    ],
    "connect-src": [
      "'self'",
      "blob:",
      backendURL,
      backendURL.replace("http", "ws"),
      regscoutBackendURL,
      ...(rexAIURL?.startsWith("/") ? [] : [rexAIURL]),
      authURL,
      idAuthURL,
      globalApiURL,
      "https://*.amazonaws.com",
      "wss://*.chime.aws",
      "wss://*.localhost:8080",
      "https://api.amplitude.com",
      "https://*.chime.aws",
      "https://*.intake-lr.com",
      "https://*.logrocket.io",
      "https://*.lr-ingest.com",
      "https://*.lr-ingest.io",
      "https://*.logrocket.com",
      "https://*.lr-in.com",
      "https://*.logr-in.com",
      "https://*.lr-in-prod.com",
      "https://static.sdkassets.chime.aws",
      "*.amplitude.com",
      "*.amazoncognito.com",
    ],
    "style-src": ["'self'", "'unsafe-inline'"],
    "img-src": [
      "'self'",
      "data:",
      "blob:",
      mediaURL,
      contentURL,
      "https://*.amazonaws.com",
    ].filter(Boolean),
    "media-src": ["'self'", "blob:", mediaURL].filter(Boolean),
    "font-src": ["'self'"],
    "worker-src": ["'self'", "blob:", "https://*.sdkassets.chime.aws"],
    "child-src": ["'self'", "blob:"],
    "frame-src": ["'self'", "blob:", idAuthURL],
    "object-src": ["'self'", "blob:"],
  };

  return Object.entries(csp)
    .map(([directive, list]) => [directive, list.join(" ")].join(" ").concat(";"))
    .join(" ");
};
